/* MT product page (product template) */
  function mtGetMoneyConfig(scope) {
    var root = scope && scope.closest ? scope.closest('mt-product') : null;
    if (!root) return {};
    if (root._mtMoneyConfig) return root._mtMoneyConfig;

    var node = root.querySelector('[data-product-money-config]');
    try {
      root._mtMoneyConfig = node ? JSON.parse(node.textContent) : {};
    } catch (e) {
      root._mtMoneyConfig = {};
    }
    return root._mtMoneyConfig;
  }

  function mtStripMoneyHtml(value) {
    return String(value || '')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, '\u00a0')
      .replace(/&amp;/g, '&')
      .trim();
  }

  function mtFormatWithDelimiters(cents, precision, thousands, decimal) {
    var number = (Math.round(Number(cents)) / 100).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function mtApplyMoneyFormat(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents) || !format) return '';

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        var shopifyFormatted = Shopify.formatMoney(cents, format);
        if (shopifyFormatted) return mtStripMoneyHtml(shopifyFormatted);
      } catch (e) {}
    }

    var placeholder = String(format).match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholder) return '';

    var amount = '';
    switch (placeholder[1]) {
      case 'amount':
        amount = mtFormatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        amount = mtFormatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        amount = mtFormatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        amount = mtFormatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        amount = mtFormatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        amount = mtFormatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        amount = mtFormatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        amount = mtFormatWithDelimiters(cents, 2, ',', '.');
    }

    return mtStripMoneyHtml(String(format).replace(/\{\{\s*\w+\s*\}\}/, amount));
  }

  function mtFormatMoney(cents, scope) {
    var config = mtGetMoneyConfig(scope);
    var formatted = mtApplyMoneyFormat(cents, config.moneyFormat);
    if (formatted) return formatted;

    var currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      config.currency ||
      'USD';
    var amount = Number(cents) / 100;
    if (config.currencySymbol) return config.currencySymbol + amount.toFixed(2);

    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  function mtRenderVariantPrice(container, variant, scope) {
    if (!container || !variant || typeof variant.price !== 'number') return;

    var onSale =
      typeof variant.compare_at_price === 'number' &&
      variant.compare_at_price > variant.price;
    var wrapper = document.createElement('span');
    wrapper.className =
      'price mt-product__price-inner' +
      (onSale ? ' price--on-sale' : '') +
      (!variant.available ? ' price--sold-out' : '');

    var current = document.createElement('span');
    current.className = 'price__now';
    current.textContent = mtFormatMoney(variant.price, scope);
    wrapper.appendChild(current);

    if (onSale) {
      var compare = document.createElement('s');
      compare.className = 'price__was';
      compare.textContent = mtFormatMoney(variant.compare_at_price, scope);
      wrapper.appendChild(compare);
    }

    container.replaceChildren(wrapper);
  }

  function mtNormalizeColor(value) {
    if (!value) return '';
    var v = String(value).toLowerCase();
    if (v.indexOf('black') !== -1) return 'black';
    if (v.indexOf('white') !== -1) return 'white';
    return v.trim();
  }

  function mtColorsMatch(a, b) {
    return mtNormalizeColor(a) === mtNormalizeColor(b) && mtNormalizeColor(a) !== '';
  }

  function mtGetSelectedColorValue(scope) {
    if (!scope) return null;
    var colorGroup = scope.querySelector('.mt-product__option-values--color, .mt-product__rec-option-values--color');
    if (!colorGroup) return null;
    var checked = colorGroup.querySelector('input:checked');
    return checked ? checked.value : null;
  }

  function mtSyncRecColor(card, mainColorValue) {
    if (!card || !mainColorValue) return;
    var colorGroup = card.querySelector('.mt-product__rec-option-values--color');
    if (!colorGroup) return;
    var target = null;
    colorGroup.querySelectorAll('[data-option-position]').forEach(function (input) {
      if (mtColorsMatch(input.value, mainColorValue)) target = input;
    });
    if (!target || target.checked) return;
    target.checked = true;
    if (typeof card.onVariantChange === 'function') card.onVariantChange();
  }

  function mtSyncRecColors(root, mainColorValue) {
    if (!root || !mainColorValue) return;
    root.querySelectorAll('rec-product-card').forEach(function (card) {
      mtSyncRecColor(card, mainColorValue);
    });
  }

  class MtProductGallery extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('mt-product');
      this.zoomDialog = this.root ? this.root.querySelector('[data-product-zoom-dialog]') : null;
      this.zoomImg = this.zoomDialog ? this.zoomDialog.querySelector('[data-product-zoom-img]') : null;

      this.addEventListener('click', (e) => {
        var t = e.target.closest('[data-target]');
        if (t) this.showMedia(t.getAttribute('data-target'));

        if (e.target.closest('[data-product-zoom]')) this.openZoom();
      });

      if (this.zoomDialog) {
        var closeBtn = this.zoomDialog.querySelector('[data-product-zoom-close]');
        var prevBtn = this.zoomDialog.querySelector('[data-product-zoom-prev]');
        var nextBtn = this.zoomDialog.querySelector('[data-product-zoom-next]');

        if (closeBtn) closeBtn.addEventListener('click', () => this.closeZoom());
        if (prevBtn) prevBtn.addEventListener('click', () => this.stepZoom(-1));
        if (nextBtn) nextBtn.addEventListener('click', () => this.stepZoom(1));

        var panel = this.zoomDialog.querySelector('.mt-product__zoom-panel');
        if (panel) {
          panel.addEventListener('click', (e) => {
            if (e.target.closest('[data-product-zoom-close], [data-product-zoom-prev], [data-product-zoom-next]')) return;
            this.closeZoom();
          });
        }

        this.zoomDialog.addEventListener('click', (e) => {
          if (e.target === this.zoomDialog) this.closeZoom();
        });

        this.zoomDialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.stepZoom(-1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.stepZoom(1);
          }
        });
      }

      this.initSlideSwipe();
    }

    initSlideSwipe() {
      var mainMedia = this.querySelector('.mt-product__main-media');
      if (!mainMedia || mainMedia.dataset.swipeReady === 'true') return;
      mainMedia.dataset.swipeReady = 'true';

      var mq = window.matchMedia('(max-width: 989px)');
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var THRESHOLD = 40;

      mainMedia.addEventListener('touchstart', (e) => {
        if (!mq.matches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      mainMedia.addEventListener('touchend', (e) => {
        if (!tracking || !mq.matches) return;
        tracking = false;
        var touch = e.changedTouches[0];
        if (!touch) return;
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < THRESHOLD) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.2) return;
        this.stepSlide(dx < 0 ? 1 : -1);
      }, { passive: true });

      mainMedia.addEventListener('touchcancel', () => {
        tracking = false;
      }, { passive: true });
    }

    getSlides() {
      return Array.from(this.querySelectorAll('[data-media-id][data-zoom-src]'));
    }

    getActiveSlide() {
      return this.querySelector('[data-media-id].is-active[data-zoom-src]');
    }

    openZoom() {
      if (!this.zoomDialog || !this.zoomImg) return;
      var slide = this.getActiveSlide();
      if (!slide) return;
      this.setZoomSlide(slide);
      if (!this.zoomDialog.open) this.zoomDialog.showModal();
    }

    closeZoom() {
      if (this.zoomDialog && this.zoomDialog.open) this.zoomDialog.close();
    }

    setZoomSlide(slide) {
      if (!slide || !this.zoomImg) return;
      this.zoomImg.src = slide.getAttribute('data-zoom-src');
      this.zoomImg.alt = slide.getAttribute('data-zoom-alt') || '';
      var id = slide.getAttribute('data-media-id');
      if (id) this.showMedia(id);
    }

    stepZoom(dir) {
      var slides = this.getSlides();
      if (slides.length < 2) return;
      var current = this.getActiveSlide();
      var index = current ? slides.indexOf(current) : 0;
      var next = (index + dir + slides.length) % slides.length;
      this.setZoomSlide(slides[next]);
    }

    stepSlide(dir) {
      var slides = this.getSlides();
      if (slides.length < 2) return;
      var current = this.getActiveSlide();
      var index = current ? slides.indexOf(current) : 0;
      var next = (index + dir + slides.length) % slides.length;
      var id = slides[next].getAttribute('data-media-id');
      if (id) this.showMedia(id);
    }

    showMedia(id) {
      if (!id) return;
      this.querySelectorAll('[data-media-id]').forEach(function (s) {
        var on = s.getAttribute('data-media-id') === id;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('hidden');
        else s.setAttribute('hidden', '');
      });
      this.querySelectorAll('[data-target]').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-target') === id);
      });

      var activeThumb = this.querySelector('[data-product-thumbs] [data-target="' + id + '"]');
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }
  }
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', MtProductGallery);
  }

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form');
      this.addEventListener('change', () => this.form && this.form.onVariantChange());
      this.variantMeta = {};
      var metaEl = this.querySelector('[data-variant-meta]');
      if (metaEl) {
        try {
          var list = JSON.parse(metaEl.textContent);
          if (Array.isArray(list)) {
            list.forEach((item) => {
              if (item && item.id != null) this.variantMeta[String(item.id)] = item;
            });
          }
        } catch (e) {}
      }

      this.multiZoomDialog = this.querySelector('[data-multi-zoom-dialog]');
      this.multiZoomImg = this.multiZoomDialog ? this.multiZoomDialog.querySelector('[data-multi-zoom-img]') : null;
      this.multiZoomIndex = 0;
      this._onMultiZoomClick = (e) => this.onMultiZoomClick(e);
      this.addEventListener('click', this._onMultiZoomClick);
      this.bindMultiZoomDialog();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onMultiZoomClick);
    }
    get selectedValues() {
      return Array.from(this.querySelectorAll('input[type=radio]:checked')).map(function (i) { return i.value; });
    }
    get isMultiAttribute() {
      return this.getAttribute('data-picker-style') === 'multi_attribute';
    }
    getMultiZoomSlides() {
      var root = this.multiZoomGroup || this;
      return Array.from(root.querySelectorAll('[data-multi-option-card]')).filter(function (card) {
        var img = card.querySelector('[data-multi-zoom-src], .mt-product__option-multi-img[src]');
        return !!img;
      });
    }
    bindMultiZoomDialog() {
      if (!this.multiZoomDialog) return;
      var closeBtn = this.multiZoomDialog.querySelector('[data-multi-zoom-close]');
      var prevBtn = this.multiZoomDialog.querySelector('[data-multi-zoom-prev]');
      var nextBtn = this.multiZoomDialog.querySelector('[data-multi-zoom-next]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeMultiZoom());
      if (prevBtn) prevBtn.addEventListener('click', () => this.stepMultiZoom(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.stepMultiZoom(1));
      this.multiZoomDialog.addEventListener('click', (e) => {
        if (e.target === this.multiZoomDialog) this.closeMultiZoom();
      });
      this.multiZoomDialog.addEventListener('keydown', (e) => {
        if (!this.multiZoomDialog.open) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.stepMultiZoom(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.stepMultiZoom(1);
        } else if (e.key === 'Escape') {
          this.closeMultiZoom();
        }
      });
      this.initMultiZoomSwipe();
    }
    initMultiZoomSwipe() {
      if (!this.multiZoomDialog || this.multiZoomDialog.dataset.swipeReady === 'true') return;
      this.multiZoomDialog.dataset.swipeReady = 'true';
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var THRESHOLD = 40;
      this.multiZoomDialog.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      this.multiZoomDialog.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches[0];
        if (!touch) return;
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        if (Math.abs(dx) < THRESHOLD) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.2) return;
        this.stepMultiZoom(dx < 0 ? 1 : -1);
      }, { passive: true });
      this.multiZoomDialog.addEventListener('touchcancel', () => {
        tracking = false;
      }, { passive: true });
    }
    onMultiZoomClick(e) {
      var btn = e.target.closest('[data-multi-zoom]');
      if (!btn || !this.contains(btn)) return;
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('[data-multi-option-card]');
      if (!card) return;
      this.multiZoomGroup = card.closest('.mt-product__option-values--multi') || this;
      var radio = card.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var slides = this.getMultiZoomSlides();
      var index = slides.indexOf(card);
      this.openMultiZoom(index < 0 ? 0 : index);
    }
    openMultiZoom(index) {
      if (!this.multiZoomDialog || !this.multiZoomImg) return;
      if (!window.matchMedia('(max-width: 989px)').matches) return;
      var slides = this.getMultiZoomSlides();
      if (!slides.length) return;
      this.multiZoomIndex = ((index % slides.length) + slides.length) % slides.length;
      this.renderMultiZoomSlide(slides[this.multiZoomIndex], true);
      if (!this.multiZoomDialog.open) this.multiZoomDialog.showModal();
    }
    closeMultiZoom() {
      if (this.multiZoomDialog && this.multiZoomDialog.open) this.multiZoomDialog.close();
    }
    stepMultiZoom(dir) {
      var slides = this.getMultiZoomSlides();
      if (slides.length < 2) return;
      this.multiZoomIndex = (this.multiZoomIndex + dir + slides.length) % slides.length;
      this.renderMultiZoomSlide(slides[this.multiZoomIndex], true);
    }
    renderMultiZoomSlide(card, selectSku) {
      if (!card || !this.multiZoomImg) return;
      var img = card.querySelector('.mt-product__option-multi-img');
      var src = (img && (img.getAttribute('data-multi-zoom-src') || img.getAttribute('src'))) || '';
      if (src) this.multiZoomImg.src = src;
      this.multiZoomImg.alt = (img && img.getAttribute('alt')) || '';
      if (!selectSku) return;
      var radio = card.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.idInput = this.querySelector('.mt-product__block--buy-buttons input[name="id"]')
        || this.querySelector('input[name="id"][data-variant-id]');
      this.selects = this.querySelector('variant-selects');
      this.form = this.closest('form');
      this.status = this.querySelector('[data-atc-status]');
      this.btn = this.querySelector('[data-atc]');
      this.section = this.dataset.section;
      this.atcDefault = this.querySelector('[data-atc-text]') ? this.querySelector('[data-atc-text]').textContent.trim() : 'Add to Cart';
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.bindBuyNow();
      this._buyNowTimer = window.setInterval(() => this.bindBuyNow(), 500);
      requestAnimationFrame(() => {
        mtSyncRecColors(this.closest('mt-product'), mtGetSelectedColorValue(this.selects));
        this.updateMultiAttributeCards();
      });
    }
    disconnectedCallback() {
      if (this._buyNowTimer) window.clearInterval(this._buyNowTimer);
    }
    onVariantChange() {
      if (!this.selects) return;
      var vals = this.selects.selectedValues;
      var match = this.variants.find(function (v) {
        return JSON.stringify(v.options) === JSON.stringify(vals);
      });
      this.querySelectorAll('[data-val-for]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-val-for'), 10) - 1;
        if (vals[pos]) el.textContent = vals[pos];
      });
      this.updateMultiAttributeCards(vals);
      var priceEl = document.getElementById('price-' + this.section);
      if (!match) { this.setUnavailable(); return; }
      this.idInput.value = match.id;
      var gallery = document.querySelector('product-gallery');
      if (match.featured_media && gallery) gallery.showMedia(String(match.featured_media.id));
      mtRenderVariantPrice(priceEl, match, this);
      var text = this.querySelector('[data-atc-text]');
      if (match.available) {
        this.btn.disabled = false;
        text.textContent = this.atcDefault;
      } else {
        this.btn.disabled = true;
        text.textContent = window.metryStrings && window.metryStrings.soldout ? window.metryStrings.soldout : 'Sold out';
      }
      mtSyncRecColors(this.closest('mt-product'), mtGetSelectedColorValue(this.selects));
    }
    updateMultiAttributeCards(vals) {
      if (!this.selects || !this.selects.isMultiAttribute) return;
      var selected = vals || this.selects.selectedValues;
      var cards = this.selects.querySelectorAll('[data-multi-option-card]');
      var self = this;
      cards.forEach(function (card) {
        var pos = parseInt(card.getAttribute('data-option-position'), 10) - 1;
        var value = card.getAttribute('data-option-value');
        if (pos < 0 || value == null) return;
        var trial = selected.slice();
        trial[pos] = value;
        var match = self.variants.find(function (v) {
          return JSON.stringify(v.options) === JSON.stringify(trial);
        });
        if (!match) {
          match = self.variants.find(function (v) {
            return v.options && v.options[pos] === value;
          });
        }
        if (!match) return;

        var media = card.querySelector('[data-multi-media]');
        var img = media && media.querySelector('img');
        var src = match.featured_image && (match.featured_image.src || match.featured_image);
        if (src && typeof src === 'string') {
          var zoomSrc = src;
          if (match.featured_image && match.featured_image.src) {
            zoomSrc = match.featured_image.src;
          }
          if (img) {
            img.src = src;
            img.setAttribute('data-multi-zoom-src', zoomSrc);
            img.removeAttribute('srcset');
          } else if (media) {
            media.innerHTML =
              '<img class="mt-product__option-multi-img" src="' + src.replace(/"/g, '&quot;') + '" data-multi-zoom-src="' + zoomSrc.replace(/"/g, '&quot;') + '" alt="" width="56" height="56" loading="lazy">' +
              '<button type="button" class="mt-product__option-multi-zoom" data-multi-zoom aria-label="Zoom image">' +
                '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
                  '<rect width="14" height="14" rx="2" fill="#000" fill-opacity=".15"/>' +
                  '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.293 3a.25.25 0 0 0-.25.25v.727c0 .138.111.25.25.25h1.623L7.404 5.75a.25.25 0 0 0 0 .352l.509.513a.25.25 0 0 0 .354 0l1.514-1.526v1.64c0 .138.112.25.25.25h.718a.25.25 0 0 0 .25-.25V3H7.293zm-.587 8a.25.25 0 0 0 .25-.25v-.727a.25.25 0 0 0-.25-.25H5.083L6.595 8.25a.25.25 0 0 0 0-.352l-.509-.513a.25.25 0 0 0-.355 0L4.217 8.911V7.27a.25.25 0 0 0-.25-.25H3.25a.25.25 0 0 0-.25.25V11h3.706z" fill="#fff"/>' +
                '</svg>' +
              '</button>';
          }
        }

        var priceWrap = card.querySelector('[data-multi-price]');
        if (priceWrap) {
          var compare = priceWrap.querySelector('[data-multi-compare]');
          var priceText = self.formatMoney(match.price);
          if (compare) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              compare.textContent = self.formatMoney(match.compare_at_price);
              compare.hidden = false;
            } else {
              compare.textContent = '';
              compare.hidden = true;
            }
            priceWrap.innerHTML = '';
            priceWrap.appendChild(document.createTextNode(priceText + ' '));
            priceWrap.appendChild(compare);
          } else {
            priceWrap.textContent = priceText;
          }
        }

        var descEl = card.querySelector('[data-multi-desc]');
        if (descEl) {
          var meta = self.selects.variantMeta[String(match.id)];
          var desc = meta && meta.desc ? String(meta.desc) : '';
          descEl.textContent = desc;
          if (desc) descEl.removeAttribute('hidden');
          else descEl.setAttribute('hidden', '');
        }
      });
    }
    setUnavailable() {
      this.btn.disabled = true;
      this.querySelector('[data-atc-text]').textContent = window.metryStrings && window.metryStrings.unavailable ? window.metryStrings.unavailable : 'Unavailable';
    }
    formatMoney(cents) {
      return mtFormatMoney(cents, this);
    }
    async onSubmit(e) {
      e.preventDefault();
      this.btn.disabled = true;
      try {
        var items = [this.getMainLineItem()];
        items = items.concat(this.getRecItems());
        var payload = items.length === 1 ? items[0] : { items: items };
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product', cartAdd: data } }));
        var showedToast = window.MtAtcToast && window.MtAtcToast.show(this.btn, data);
        if (!showedToast) {
          this.showStatus(window.metryStrings && window.metryStrings.added ? window.metryStrings.added : 'Added to cart', false);
        }
      } catch (err) {
        this.showStatus(err.message, true);
      } finally {
        this.btn.disabled = false;
      }
    }
    getMainLineItem() {
      var qtyInput = this.querySelector('.qty__input');
      return {
        id: this.idInput.value,
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
      };
    }
    getRecItems() {
      var root = this.closest('mt-product');
      if (!root) return [];
      var items = [];
      root.querySelectorAll('rec-product-card').forEach(function (card) {
        if (typeof card.getLineItem !== 'function') return;
        var line = card.getLineItem();
        if (line) items.push(line);
      });
      return items;
    }
    hasBundleAddon() {
      var mainId = this.idInput && this.idInput.value;
      if (!mainId || !window.MtBundleCart) return false;
      window.MtBundleCart.collectBundleMap();
      return !!window.MtBundleCart.getAddonVariantId(mainId);
    }
    needsCustomBuyNow() {
      return this.getRecItems().length > 0 || this.hasBundleAddon();
    }
    bindPaymentCapture(el) {
      if (!el || el.dataset.mtPaymentBound) return false;
      el.dataset.mtPaymentBound = 'true';
      el.addEventListener('click', (e) => this.onBuyNow(e), true);
      return true;
    }
    bindBuyNow() {
      var wrap = this.querySelector('.mt-product__buy-now');
      if (!wrap) return;

      this.bindPaymentCapture(wrap);

      var checkout = wrap.querySelector('shopify-accelerated-checkout');
      var shadowReady = true;
      if (checkout) {
        if (checkout.shadowRoot) {
          this.bindPaymentCapture(checkout.shadowRoot);
          shadowReady = !!checkout.shadowRoot.dataset.mtPaymentBound;
        } else {
          shadowReady = false;
        }
      }

      if (wrap.dataset.mtPaymentBound && shadowReady && this._buyNowTimer) {
        window.clearInterval(this._buyNowTimer);
        this._buyNowTimer = null;
      }
    }
    buildBuyNowPayload() {
      var items = [this.getMainLineItem()].concat(this.getRecItems());
      var payload = { items: items };
      if (window.MtBundleCart && typeof window.MtBundleCart.expandAddPayload === 'function') {
        window.MtBundleCart.collectBundleMap();
        payload = window.MtBundleCart.expandAddPayload(payload);
      }
      return payload;
    }
    async onBuyNow(e) {
      if (!this.needsCustomBuyNow()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try {
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(this.buildBuyNowPayload())
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        window.location.href = '/checkout';
      } catch (err) {
        this.showStatus(err.message, true);
      }
    }
    showStatus(msg, isError) {
      if (!this.status) return;
      this.status.textContent = msg;
      this.status.hidden = false;
      this.status.classList.toggle('is-error', !!isError);
    }
  }
  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  class RecProductCard extends HTMLElement {
    connectedCallback() {
      var variantsEl = this.querySelector('[data-variants]');
      if (!variantsEl) return;
      this.variants = JSON.parse(variantsEl.textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.selectInput = this.querySelector('[data-rec-select]');
      this.priceEl = this.querySelector('[data-rec-price]');
      this.badgeEl = this.querySelector('[data-rec-badge]');
      this.badgeAmountEl = this.querySelector('[data-rec-badge-amount]');
      this.qtyInput = this.querySelector('[data-rec-qty]');
      this.atcBtn = this.querySelector('[data-rec-atc]');
      var wrap = this.closest('[data-rec-wrap]');
      this.savePrefix = wrap ? wrap.getAttribute('data-rec-save-prefix') : 'SAVE';

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-position]')) this.onVariantChange();
      });
      this.addEventListener('click', (e) => {
        var atc = e.target.closest('[data-rec-atc]');
        if (atc && this.contains(atc)) {
          e.preventDefault();
          this.addToCart();
          return;
        }
        var btn = e.target.closest('[data-qty]');
        if (btn) this.stepQty(btn.getAttribute('data-qty'));
      });
    }
    selectedValues() {
      return Array.from(this.querySelectorAll('[data-option-position]:checked')).map(function (i) { return i.value; });
    }
    onVariantChange() {
      var vals = this.selectedValues();
      var match = this.variants.find(function (v) {
        return JSON.stringify(v.options) === JSON.stringify(vals);
      });
      if (!match) return;
      this.idInput.value = match.id;
      this.updatePrice(match);
      this.updateBadge(match);
      this.updateAvailability(match);
      if (match.featured_image && match.featured_image.src) {
        var img = this.querySelector('[data-rec-media] img');
        if (img) {
          img.src = match.featured_image.src;
          img.removeAttribute('srcset');
        }
      }
    }
    updatePrice(variant) {
      if (!this.priceEl) return;
      var current = this.priceEl.querySelector('.mt-product__rec-price-current');
      var compare = this.priceEl.querySelector('.mt-product__rec-price-compare');
      if (current) current.textContent = this.formatMoney(variant.price);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.textContent = this.formatMoney(variant.compare_at_price);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
    }
    updateBadge(variant) {
      if (!this.badgeEl) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var save = variant.compare_at_price - variant.price;
        if (this.badgeAmountEl) {
          this.badgeAmountEl.innerHTML = '<span class="money">' + this.formatMoney(save) + '</span>';
        }
        this.badgeEl.hidden = false;
      } else {
        this.badgeEl.hidden = true;
      }
    }
    updateAvailability(variant) {
      if (!variant.available) {
        this.classList.add('is-unavailable');
        if (this.selectInput) {
          this.selectInput.checked = false;
          this.selectInput.disabled = true;
        }
        if (this.atcBtn) this.atcBtn.disabled = true;
      } else {
        this.classList.remove('is-unavailable');
        if (this.selectInput) this.selectInput.disabled = false;
        if (this.atcBtn) this.atcBtn.disabled = false;
      }
    }
    stepQty(dir) {
      if (!this.qtyInput) return;
      var value = parseInt(this.qtyInput.value, 10) || 1;
      this.qtyInput.value = dir === 'plus' ? value + 1 : Math.max(1, value - 1);
    }
    getLineItem() {
      if (!this.selectInput || !this.selectInput.checked || this.selectInput.disabled) return null;
      if (!this.idInput || !this.idInput.value) return null;
      return {
        id: this.idInput.value,
        quantity: parseInt(this.qtyInput && this.qtyInput.value, 10) || 1
      };
    }
    async addToCart() {
      if (!this.atcBtn || this.atcBtn.disabled) return;
      if (!this.idInput || !this.idInput.value) return;
      this.atcBtn.disabled = true;
      this.atcBtn.classList.add('is-loading');
      try {
        var payload = {
          items: [{
            id: this.idInput.value,
            quantity: parseInt(this.qtyInput && this.qtyInput.value, 10) || 1
          }]
        };
        if (window.MtBundleCart && typeof window.MtBundleCart.expandAddPayload === 'function') {
          window.MtBundleCart.collectBundleMap();
          payload = window.MtBundleCart.expandAddPayload(payload);
        }
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'rec-product', cartAdd: data } }));
        // Drawer opens via cart:updated; skip mobile toast to avoid double feedback.
      } catch (err) {
        console.error(err);
      } finally {
        if (!this.classList.contains('is-unavailable')) this.atcBtn.disabled = false;
        this.atcBtn.classList.remove('is-loading');
      }
    }
    formatMoney(cents) {
      return mtFormatMoney(cents, this);
    }
  }
  if (!customElements.get('rec-product-card')) {
    customElements.define('rec-product-card', RecProductCard);
  }

  function bindDirectionFill(buttons, fillSelector, axis) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vertical = axis === 'y';

    buttons.forEach(function (btn) {
      var fill = btn.querySelector(fillSelector);
      if (!fill || btn.disabled) return;

      var side = function (e) {
        var rect = btn.getBoundingClientRect();
        if (vertical) {
          return e.clientY < rect.top + rect.height / 2 ? 'center top' : 'center bottom';
        }
        return e.clientX < rect.left + rect.width / 2 ? 'left center' : 'right center';
      };

      btn.addEventListener('pointerenter', function (e) {
        if (reduceMotion) {
          btn.classList.add('is-fill');
          return;
        }
        fill.style.transition = 'none';
        fill.style.transformOrigin = side(e);
        void fill.offsetWidth;
        fill.style.transition = 'transform 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.transform = vertical ? 'scaleY(1)' : 'scaleX(1)';
        btn.classList.add('is-fill');
      });

      btn.addEventListener('pointerleave', function (e) {
        if (reduceMotion) {
          btn.classList.remove('is-fill');
          return;
        }
        fill.style.transformOrigin = side(e);
        fill.style.transform = vertical ? 'scaleY(0)' : 'scaleX(0)';
        btn.classList.remove('is-fill');
      });
    });
  }

  function bindClipFill(buttons, fillSelector, axis) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vertical = axis === 'y';
    var hiddenStart = vertical ? 'inset(100% 0 0 0 round 999px)' : 'inset(0 100% 0 0 round 999px)';
    var hiddenEnd = vertical ? 'inset(0 0 100% 0 round 999px)' : 'inset(0 0 0 100% round 999px)';
    var shown = 'inset(0 0 0 0 round 999px)';

    buttons.forEach(function (btn) {
      var fill = btn.querySelector(fillSelector);
      if (!fill || btn.disabled) return;

      var hiddenFor = function (e) {
        var rect = btn.getBoundingClientRect();
        if (vertical) {
          return e.clientY < rect.top + rect.height / 2 ? hiddenStart : hiddenEnd;
        }
        return e.clientX < rect.left + rect.width / 2 ? hiddenStart : hiddenEnd;
      };

      var unsettle = function () {
        btn.classList.remove('is-fill-settled');
      };

      var settle = function () {
        btn.classList.add('is-fill-settled');
      };

      fill.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'clip-path') return;
        if (btn.classList.contains('is-fill')) settle();
        else unsettle();
      });

      btn.addEventListener('pointerenter', function (e) {
        unsettle();
        if (reduceMotion) {
          fill.style.clipPath = shown;
          btn.classList.add('is-fill');
          settle();
          return;
        }
        fill.style.transition = 'none';
        fill.style.clipPath = hiddenFor(e);
        void fill.offsetWidth;
        fill.style.transition = 'clip-path 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.clipPath = shown;
        btn.classList.add('is-fill');
      });

      btn.addEventListener('pointerleave', function (e) {
        unsettle();
        if (reduceMotion) {
          fill.style.clipPath = hiddenStart;
          btn.classList.remove('is-fill');
          return;
        }
        fill.style.transition = 'clip-path 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.clipPath = hiddenFor(e);
        btn.classList.remove('is-fill');
      });
    });
  }

  if (!customElements.get('mt-product')) {
    customElements.define('mt-product', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-compare-dialog]');
        this.openBtn = this.querySelector('[data-compare-open]');
        this.closeBtn = this.querySelector('[data-compare-close]');
        this.recExpand = this.querySelector('[data-rec-expand]');
        this.recWrap = this.querySelector('[data-rec-wrap]');
        this.video = this.querySelector('[data-product-video]');

        if (this.openBtn && this.dialog) {
          this.openBtn.addEventListener('click', () => this.dialog.showModal());
        }
        if (this.closeBtn && this.dialog) {
          this.closeBtn.addEventListener('click', () => this.dialog.close());
        }
        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.dialog.close();
          });
        }

        this.querySelectorAll('[data-compare-tab]').forEach((tab) => {
          tab.addEventListener('click', () => this.setCompareTab(tab));
        });

        if (this.recExpand && this.recWrap) {
          var expandLabel = this.recExpand.getAttribute('aria-label') || 'Show more';
          var collapseLabel = this.recExpand.getAttribute('data-rec-collapse-label')
            || this.recExpand.getAttribute('data-collapse-label')
            || 'Show fewer recommendations';
          this.recExpand.addEventListener('click', () => {
            var expanded = this.recWrap.classList.toggle('is-expanded');
            this.recExpand.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            this.recExpand.setAttribute('aria-label', expanded ? collapseLabel : expandLabel);
          });
        }

        this.querySelectorAll('[data-copy-code]').forEach((btn) => {
          btn.addEventListener('click', () => {
            var code = btn.getAttribute('data-copy-code');
            if (code && navigator.clipboard) navigator.clipboard.writeText(code);
            btn.textContent = btn.dataset.copiedLabel || 'Copied';
            setTimeout(function () {
              btn.textContent = btn.dataset.defaultLabel || 'Copy';
            }, 1500);
          });
          btn.dataset.defaultLabel = btn.textContent.trim();
        });

        var thumbs = this.querySelector('[data-product-thumbs]');
        if (thumbs) {
          var prev = this.querySelector('[data-thumb-prev]');
          var next = this.querySelector('[data-thumb-next]');
          if (prev) prev.addEventListener('click', () => thumbs.scrollBy({ top: -90, behavior: 'smooth' }));
          if (next) next.addEventListener('click', () => thumbs.scrollBy({ top: 90, behavior: 'smooth' }));
        }

        bindDirectionFill(this.querySelectorAll('.mt-product__thumb-arrow'), '.mt-product__thumb-arrow-fill', 'y');
        bindClipFill(this.querySelectorAll('.mt-product__atc'), '.mt-product__atc-fill', 'y');
        bindDirectionFill(this.querySelectorAll('.mt-product__rec-expand'), '.mt-product__rec-expand-fill');
        bindDirectionFill(this.querySelectorAll('.mt-product__compare-plus'), '.mt-product__compare-plus-fill');

        if (this.video) {
          var playBtn = this.querySelector('[data-video-play]');
          var pauseBtn = this.querySelector('[data-video-pause]');

          var loadVideo = () => {
            this.video.querySelectorAll('source[data-src]').forEach((s) => {
              if (!s.src) s.src = s.getAttribute('data-src');
            });
            if (this.video.readyState < 1) this.video.load();
          };

          var syncVideoControls = () => {
            if (!playBtn || !pauseBtn) return;
            var playing = !this.video.paused && !this.video.ended;
            playBtn.classList.toggle('is-hidden', playing);
            pauseBtn.classList.toggle('is-hidden', !playing);
          };

          if (playBtn) {
            playBtn.addEventListener('click', () => {
              loadVideo();
              var p = this.video.play();
              if (p && p.catch) p.catch(function () {});
            });
          }
          if (pauseBtn) {
            pauseBtn.addEventListener('click', () => {
              this.video.pause();
            });
          }

          this.video.addEventListener('play', syncVideoControls);
          this.video.addEventListener('pause', syncVideoControls);
          this.video.addEventListener('ended', syncVideoControls);
          syncVideoControls();

          this._videoIo = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) loadVideo();
            });
          }, { threshold: 0.2 });
          this._videoIo.observe(this.video);

          if (this.video.getBoundingClientRect().top < window.innerHeight) {
            loadVideo();
          }
        }
      }

      disconnectedCallback() {
        if (this._videoIo) this._videoIo.disconnect();
      }

      setCompareTab(tab) {
        var index = tab.getAttribute('data-index');
        this.querySelectorAll('[data-compare-tab]').forEach((el) => {
          var on = el === tab;
          el.classList.toggle('is-active', on);
          el.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-compare-value]').forEach((val) => {
          val.classList.toggle('is-active', val.getAttribute('data-index') === index);
        });
        if (window.matchMedia('(max-width: 989px)').matches) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    });
  }

  /* from sections/mt-media-hero.liquid */
  if (!customElements.get('mt-media-hero')) {
    customElements.define('mt-media-hero', class extends HTMLElement {
      connectedCallback() {
        this.deskVideo = this.querySelector('[data-video-desk]');
        this.mobVideo = this.querySelector('[data-video-mob]');
        this.deskControls = this.querySelector('[data-controls-desk]');
        this.mobControls = this.querySelector('[data-controls-mob]');

        if (this.deskVideo && this.deskControls) {
          this.bindVideo(this.deskVideo, this.deskControls, false);
        }
        if (this.mobVideo && this.mobControls) {
          this.bindVideo(this.mobVideo, this.mobControls, true);
        }

        this._mq = window.matchMedia('(min-width: 750px)');
        this._onMq = () => this.syncActiveVideo();
        if (this._mq.addEventListener) {
          this._mq.addEventListener('change', this._onMq);
        } else {
          this._mq.addListener(this._onMq);
        }
      }

      disconnectedCallback() {
        if (this._videoIo) this._videoIo.disconnect();
        if (this._mq && this._onMq) {
          if (this._mq.removeEventListener) {
            this._mq.removeEventListener('change', this._onMq);
          } else {
            this._mq.removeListener(this._onMq);
          }
        }
      }

      bindVideo(video, controls, isMobile) {
        var playBtn = controls.querySelector('[data-video-play]');
        var pauseBtn = controls.querySelector('[data-video-pause]');

        var loadVideo = () => {
          video.querySelectorAll('source[data-src]').forEach(function (s) {
            if (!s.src) s.src = s.getAttribute('data-src');
          });
          if (video.querySelector('source[src]') && video.readyState < 1) video.load();
        };

        var syncControls = () => {
          var playing = !video.paused && !video.ended;
          if (playBtn) playBtn.classList.toggle('is-hidden', playing);
          if (pauseBtn) pauseBtn.classList.toggle('is-hidden', !playing);
          if (isMobile) this.classList.toggle('is-playing', playing);
        };

        if (playBtn) {
          playBtn.addEventListener('click', () => {
            this.pauseInactiveVideos(video);
            loadVideo();
            var p = video.play();
            if (p && p.then) {
              p.then(function () { syncControls(); }).catch(function () { syncControls(); });
            } else {
              syncControls();
            }
          });
        }

        if (pauseBtn) {
          pauseBtn.addEventListener('click', () => {
            video.pause();
          });
        }

        video.addEventListener('play', syncControls);
        video.addEventListener('pause', syncControls);
        video.addEventListener('ended', syncControls);
        syncControls();

        if (!this._videoIo) {
          this._videoIo = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.querySelectorAll('source[data-src]').forEach(function (s) {
                  if (!s.src) s.src = s.getAttribute('data-src');
                });
                if (entry.target.readyState < 1) entry.target.load();
              }
            });
          }, { threshold: 0.15 });
        }
        this._videoIo.observe(video);

        if (video.getBoundingClientRect().top < window.innerHeight) {
          loadVideo();
        }
      }

      pauseInactiveVideos(active) {
        [this.deskVideo, this.mobVideo].forEach(function (v) {
          if (v && v !== active && !v.paused) v.pause();
        });
      }

      syncActiveVideo() {
        var deskVisible = this._mq && this._mq.matches;
        if (deskVisible && this.mobVideo && !this.mobVideo.paused) {
          this.mobVideo.pause();
        }
        if (!deskVisible && this.deskVideo && !this.deskVideo.paused) {
          this.deskVideo.pause();
        }
      }
    });
  }

  /* from sections/mt-feature-split.liquid */
  if (!customElements.get('mt-feature-split')) {
    customElements.define('mt-feature-split', class extends HTMLElement {
      connectedCallback() {
        this._videoIo = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              var video = entry.target;
              var item = video.closest('.mt-feature-split__item');
              if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
                this.loadVideo(video);
                var p = video.play();
                if (p && p.then) {
                  p.then(function () {
                    if (item) item.classList.add('is-playing');
                  }).catch(function () {});
                } else if (item) {
                  item.classList.add('is-playing');
                }
              } else {
                video.pause();
                if (item) item.classList.remove('is-playing');
              }
            });
          },
          { threshold: [0, 0.45, 0.75] }
        );

        this.querySelectorAll('[data-feature-video]').forEach((video) => {
          this._videoIo.observe(video);
        });
      }

      disconnectedCallback() {
        if (this._videoIo) this._videoIo.disconnect();
      }

      loadVideo(video) {
        video.querySelectorAll('source[data-src]').forEach(function (source) {
          if (!source.src) source.src = source.getAttribute('data-src');
        });
        if (video.readyState < 2) video.load();
      }
    });
  }

  /* from sections/mt-gallery-columns.liquid */
  if (!customElements.get('mt-gallery-columns')) {
    customElements.define('mt-gallery-columns', class extends HTMLElement {
      connectedCallback() {
        this.syncAutoplay();
        this.bindVideos();
        this._motionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._onMotion = () => this.syncAutoplay();
        if (this._motionMq.addEventListener) {
          this._motionMq.addEventListener('change', this._onMotion);
        } else if (this._motionMq.addListener) {
          this._motionMq.addListener(this._onMotion);
        }
      }

      disconnectedCallback() {
        if (this._motionMq && this._onMotion) {
          if (this._motionMq.removeEventListener) {
            this._motionMq.removeEventListener('change', this._onMotion);
          } else if (this._motionMq.removeListener) {
            this._motionMq.removeListener(this._onMotion);
          }
        }
      }

      bindVideos() {
        var root = this;
        this.dialog = this.querySelector('[data-gallery-dialog]');
        this.dialogVideo = this.querySelector('[data-gallery-dialog-video]');
        this.dialogClose = this.querySelector('[data-gallery-dialog-close]');

        if (this.dialog && !this.dialog._gcBound) {
          this.dialog._gcBound = true;
          if (this.dialogClose) {
            this.dialogClose.addEventListener('click', function () {
              root.closeVideoDialog();
            });
          }
          this.dialog.addEventListener('click', function (event) {
            if (event.target === root.dialog) root.closeVideoDialog();
          });
          this.dialog.addEventListener('close', function () {
            root.resetDialogVideo();
          });
        }

        this.querySelectorAll('[data-gallery-open]').forEach(function (trigger) {
          if (trigger._gcBound) return;
          trigger._gcBound = true;
          trigger.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            root.openVideoDialog(trigger);
          });
        });
      }

      resetDialogVideo() {
        var video = this.dialogVideo;
        if (!video) return;
        video.pause();
        video.removeAttribute('poster');
        video.innerHTML = '';
      }

      closeVideoDialog() {
        if (this.dialog && this.dialog.open) this.dialog.close();
      }

      openVideoDialog(trigger) {
        var dialog = this.dialog;
        var video = this.dialogVideo;
        if (!trigger || !dialog || !video) return;

        var sourcesRaw = trigger.getAttribute('data-video-sources');
        if (!sourcesRaw) return;

        var sources;
        try {
          sources = JSON.parse(sourcesRaw);
        } catch (error) {
          return;
        }
        if (!sources || !sources.length) return;

        this.resetDialogVideo();

        sources.forEach(function (source) {
          if (!source || !source.url) return;
          var el = document.createElement('source');
          el.src = source.url;
          el.type = source.type || 'video/mp4';
          video.appendChild(el);
        });

        var poster = trigger.getAttribute('data-video-poster');
        if (poster) video.setAttribute('poster', poster);

        video.load();
        dialog.showModal();

        var start = function () {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        };

        if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
          start();
        } else {
          video.addEventListener('canplay', start, { once: true });
        }
      }

      syncAutoplay() {
        var allow = this.dataset.autoplay === 'true'
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.classList.toggle('is-autoplay', allow);
      }
    });
  }

  /* from sections/mt-shot-video.liquid */
  if (!customElements.get('mt-shot-video')) {
    customElements.define('mt-shot-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('[data-shot-video]');
        if (!this.video) return;

        this.video.muted = true;
        this.video.playsInline = true;
        this.video.loop = true;
        this.video.controls = false;
        this.video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
        this.video.disablePictureInPicture = true;

        this._io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
                var playPromise = this.video.play();
                if (playPromise && playPromise.catch) {
                  playPromise.catch(function () {});
                }
              } else {
                this.video.pause();
              }
            });
          },
          { threshold: [0, 0.35, 0.6] }
        );
        this._io.observe(this.video);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }
    });
  }
